import { axiosInstance } from "@/api/apiClient";
import {
  PagedBusinessCallLogOutSchema,
  PagedCallQueueContactOutSchema,
  PagedDialGroupOutSchema,
  PagedMinimalUserContactSchema,
  PagedProfileMinimalOutSchemaV2,
  PagedVoicemailMessageOutSchema,
} from "@/api/client";
import { CustomAxiosRequestConfig } from "@/api/types";

export type PublicKeyResponse = {
  public_key: string;
};

export type GetEncryptionKeyRequest = {
  options?: CustomAxiosRequestConfig;
};

export const getEncryptionKey = async ({
  options,
}: GetEncryptionKeyRequest = {}) => {
  return axiosInstance.get<PublicKeyResponse>("/public-key/", {
    accessLevel: "public",
    ...options,
  } as CustomAxiosRequestConfig);
};

export type GetCallConfigDialGroupFromLinkRequest = {
  link: string;
  options?: CustomAxiosRequestConfig;
};

export const getCallConfigDialGroupFromLink = async ({
  link,
  options,
}: GetCallConfigDialGroupFromLinkRequest) => {
  return axiosInstance.get<PagedDialGroupOutSchema>(link, options);
};

export type GetVoiceMailMessagesFromLinkRequest = {
  link: string;
  options?: CustomAxiosRequestConfig;
};

export const getVoiceMailMessagesFromLink = async ({
  link,
  options,
}: GetVoiceMailMessagesFromLinkRequest) => {
  return axiosInstance.get<PagedVoicemailMessageOutSchema>(link, options);
};

export type GetContactsFromLinkRequest = {
  link: string;
  options?: CustomAxiosRequestConfig;
};

export const getContactsFromLink = async ({
  link,
  options,
}: GetContactsFromLinkRequest) => {
  return axiosInstance.get<PagedMinimalUserContactSchema>(link, options);
};

export type GetBusinessCallLogsFromLinkRequest = {
  link: string;
  options?: CustomAxiosRequestConfig;
};

export const getBusinessCallLogsFromLink = async ({
  link,
  options,
}: GetBusinessCallLogsFromLinkRequest) => {
  return axiosInstance.get<PagedBusinessCallLogOutSchema>(link, options);
};

export type ExportBusinessCallLogsViaEmailRequest = {
  link: string;
  options?: CustomAxiosRequestConfig;
};

export const exportBusinessCallLogsViaEmailFromLink = async ({
  link,
  options,
}: ExportBusinessCallLogsViaEmailRequest) => {
  return axiosInstance.get<void>(link, options);
};

export type GetTeamMembersV2Request = {
  link: string;
  options?: CustomAxiosRequestConfig;
};

export const getTeamMembersV2FromLink = async ({
  link,
  options,
}: GetTeamMembersV2Request) => {
  return axiosInstance.get<PagedProfileMinimalOutSchemaV2>(link, options);
};

export type GetCallQueueItemsFromLinkRequest = {
  link: string;
  options?: CustomAxiosRequestConfig;
};

export const getCallQueueItemsFromLink = async ({
  link,
  options,
}: GetCallQueueItemsFromLinkRequest) => {
  return axiosInstance.get<PagedCallQueueContactOutSchema>(link, options);
};
